import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CInputCheckbox
} from "@coreui/react"
import downArrow from "assets/icons/downArrow.svg"
import PropTypes from "prop-types"
import React from "react"

function MultiSelectDropdown({
  items,
  selectedKeys,
  onChange,
  defaultText,
  emptyText,
  className,
  buttonClassName,
  showArrow = true,
  arrowIcon
}) {
  const handleChange = (itemKey) => {
    onChange(
      selectedKeys.includes(itemKey)
        ? selectedKeys.filter((key) => key !== itemKey)
        : [...selectedKeys, itemKey]
    )
  }

  return (
    <CDropdown className={className}>
      <CDropdownToggle
        className={`bg-white d-flex align-items-center justify-content-between ${buttonClassName}`}
        caret
      >
        {!selectedKeys.length ? emptyText : defaultText(selectedKeys.length)}
        {showArrow && arrowIcon}
      </CDropdownToggle>
      <CDropdownMenu className="dropdown-menu">
        {items.map((item) => (
          <CDropdownItem
            key={item.key}
            disabled={item.disabled}
            onClick={() => handleChange(item.key)}
            className="pl-4 d-flex align-items-baseline"
          >
            <CInputCheckbox
              checked={selectedKeys.includes(item.key)}
              disabled={item.disabled}
              readOnly
            />
            {item.text}
          </CDropdownItem>
        ))}
      </CDropdownMenu>
    </CDropdown>
  )
}

MultiSelectDropdown.defaultProps = {
  items: [],
  selectedkeys: [],
  onChange: () => {},
  emptyText: "",
  defaultText: (count) => `${count} item(s) selected`,
  className: "",
  buttonClassName: "",
  arrowIcon: (
    <img src={downArrow} alt="down arrow" className="iconDropdownStyle" />
  )
}

MultiSelectDropdown.propTypes = {
  items: PropTypes.array,
  selectedKeys: PropTypes.array,
  emptyText: PropTypes.string,
  defaultText: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  arrowIcon: PropTypes.element,
  showArrow: PropTypes.bool
}

export default MultiSelectDropdown
